import React, { useEffect, useMemo, useState } from "react";
import { format } from "date-fns";
import { Box, Typography } from "@mui/material";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";

function ServerDay(props) {
  const { highlightedDays = [], day, ...other } = props;
  const formattedDay = format(day, "yyyy-MM-dd");
  const isSelected = highlightedDays.indexOf(formattedDay) >= 0;

  return (
    <PickersDay
      {...other}
      day={day}
      sx={{
        borderRadius: "50%",
        backgroundColor: isSelected ? "grey.400" : "inherit",
        color: isSelected ? "primary.contrastText" : "inherit",
      }}
    />
  );
}

export default function TrackerCalendar({ groupedDeeds = [], totalCount = 0 }) {
  const [highlightedDays, setHighlightedDays] = useState([]);

  useEffect(() => {
    const days = groupedDeeds
      .filter((group) => group.deeds.length > 0)
      .map((group) => format(new Date(group.deeds[0].dateTime), "yyyy-MM-dd"));
    setHighlightedDays(days);
  }, [groupedDeeds]);

  const latestDay = useMemo(() => {
    if (highlightedDays.length === 0) return new Date();
    const sorted = [...highlightedDays].sort();
    return new Date(sorted[sorted.length - 1]);
  }, [highlightedDays]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateCalendar
        value={latestDay}
        style={{ minHeight: "360px" }}
        views={["day"]}
        showDaysOutsideCurrentMonth
        fixedWeekNumber={5}
        slots={{ day: ServerDay }}
        slotProps={{ day: { highlightedDays } }}
      />
      <Box
        display="flex"
        justifyContent="center"
        sx={{ maxWidth: { xs: "343px", sm: "600px" }, margin: "auto" }}
      >
        <Box width={"100%"} mt={-4}>
          <Typography variant="body2" color="text.secondary">
            {`${totalCount} result${totalCount !== 1 ? "s" : ""}`}
          </Typography>
        </Box>
      </Box>
    </LocalizationProvider>
  );
}
